import { customFetch } from '#/services/customFetch'
import type {
  TeacherListParams,
  TeacherPaginatedResponse,
} from '../types/teacher.types'

export async function getTeachers(
  params: TeacherListParams = {},
): Promise<TeacherPaginatedResponse> {
  const query = new URLSearchParams()
  if (params.page) query.set('page', params.page.toString())
  if (params.limit) query.set('limit', params.limit.toString())
  if (params.search) query.set('search', params.search)

  const queryString = query.toString()
  const endpoint = `/student/teachers${queryString ? `?${queryString}` : ''}`

  return customFetch<TeacherPaginatedResponse>(endpoint)
}
